<script>
import styled from '@u-rogel/vue-emotion'

export default styled.div`
`()
</script>
